import { Leaf, X, Minus } from "lucide-react";
import { GREEN_BULLETS, GREEN_METHODS } from "../../mock";
import { useContent } from "../../context/ContentContext";

export default function GreenCertified() {
  const { c } = useContent();
  const g = c.greenCertified;
  const statusStyle = (s) => (s === "NO" ? "text-rose-600 ring-rose-200" : "text-amber-600 ring-amber-200");
  const statusIcon = (s) => (s === "NO" ? <X size={13} /> : <Minus size={13} />);

  return (
    <section className="bg-white py-20 lg:py-24">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-12 px-5 lg:grid-cols-2 lg:px-8">
        <div>
          <p className="eyebrow">{g.eyebrow}</p>
          <h2 className="font-display mt-3 text-[32px] font-extrabold tracking-tight text-[var(--ink)] sm:text-[40px]">{g.title}</h2>
          <p className="mt-4 max-w-lg text-[16px] leading-relaxed text-slate-500">{g.description}</p>
          <div className="mt-7 flex flex-wrap gap-2.5">
            {GREEN_BULLETS.map((b, i) => (
              <span key={i} className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3.5 py-2 text-[13px] font-semibold text-[var(--ink)]">
                <Leaf size={13} className="text-emerald-500" />
                {b}
              </span>
            ))}
          </div>
        </div>

        <div className="rounded-2xl border border-slate-200 bg-white p-7 shadow-[0_10px_40px_-24px_rgba(15,36,56,0.3)]">
          <h3 className="font-display text-[19px] font-bold text-[var(--ink)]">{g.cardTitle}</h3>
          <div className="mt-4">
            {GREEN_METHODS.map((m, i) => (
              <div key={i} className={`flex items-center justify-between py-4 ${i < GREEN_METHODS.length - 1 ? "border-b border-slate-100" : ""}`}>
                <div>
                  <div className="text-[15px] font-bold text-[var(--ink)]">{m.name}</div>
                  <div className="text-[13px] text-slate-500">{m.note}</div>
                </div>
                <span className={`inline-flex items-center gap-1 rounded-full bg-white px-3 py-1 text-[12px] font-bold ring-1 ${statusStyle(m.status)}`}>
                  {statusIcon(m.status)} {m.status}
                </span>
              </div>
            ))}
          </div>
          <p className="mt-4 text-[13px] leading-relaxed text-slate-400">{g.note}</p>
        </div>
      </div>
    </section>
  );
}
